var $ = require('jquery')
var swal = require('sweetalert')
var autocomplete = require('devbridge-autocomplete')

$('.js-autocomplete').autocomplete({
    serviceUrl: '/autocomplete',
    paramName: 'q',
    dataType: 'json',
    minChars: 3,
    transformResult: function(response) {
        return {
            suggestions: $.map(response, function(dataItem) {
                let catPath = dataItem.cat_path.split(',')[0];
                return {
                    value: dataItem.title,
                    data: {
                        path: dataItem.path,
                        catPath: catPath,
                        location: dataItem.location
                    }
                };
            })
        };
    },
    onSelect: function(suggestions) {
        let locationPath = $('.js-header-cities__btn').attr('data-path');

        if (suggestions.data.catPath === null) {
            location.href = window.location.protocol +
                '//' + window.location.host + '/' + suggestions.data.location + '/'
                + suggestions.data.path;
        } else {
            location.href = window.location.protocol +
                '//' + window.location.host + '/' + suggestions.data.location + '/'
                + suggestions.data.catPath + '/' + suggestions.data.path;
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/search/search-autocomplete.js